import $ from 'jquery';
import { updateMiniCart } from '../modules/SubmitAddCart';

export default {
    init() {
        $(document).on('submit', 'form.formRebuy', function(e) {
            e.preventDefault();
            const url = $(this).attr("action");

            $.ajax({
                type: "POST", 
                data: $(this).serialize(), 
                url,
                success: updateMiniCart,
                error: function (e) {
                    console.log('Error.', e);
                }
            });
        return false;
        })

    },
    finalize() {

    },
};



// WEBPACK FOOTER //
// ./assets/src/js/routes/account.js